import { combineReducers } from 'redux';
import { generalAppStateReducer } from './general/generalAppStateSlice';
import { ordersStateReducer } from './orders/reducer';
import { currenciesReducer } from 'app/currencies/store/reducer';
import { appSettingsReducer } from './appSettings/reducer';
import { featureTogglesStateReducer } from './featureToggles/reducer';
import { shareUsersReducer } from './shareUsers/reducer';
import { connectivityReducer } from 'app/store/connectivity/connectivityStateSlice';

export const appStateReducer = combineReducers({
    appSettings: appSettingsReducer,
    connectivity: connectivityReducer,
    general: generalAppStateReducer,
    currencies: currenciesReducer,
    featureToggles: featureTogglesStateReducer,
    orders: ordersStateReducer,
    shareUsers: shareUsersReducer,
});
